import Request from './request'

export default class userProductService {
  static async getListUserProductsService(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/Product/user/getList',
        data: data,
        token: false
      }).then((result = {}) => {
        const { statusCode, data } = result
        if (statusCode === 200) {
          return resolve(data)
        } else {
          return resolve({})
        }
      })
    })
  }

  static async PartnerAPIProductUserGetList(data) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/PartnerAPI/Product/user/getList',
        data: data,
        token: false
      }).then((result = {}) => {
        return resolve(result)
      })
    })
  }
}
